import React from 'react'
import { createPortal } from 'react-dom'

import CountUpWrapper from 'src/components/CountUpWrapper'
import Progress from './Progress'
import Footer from './Footer'
import useBreakdown from './useBreakdown'

import formatUsdAmount from 'src/utils/formatUsdAmount'

const Content = ({
  getTotals, partnerItem, partnerItems, widget, sendMessage,
  expanded, toggleExpanded, footer, fundraiserUrl, donateLabel,
}) => {
  const breakdown = useBreakdown({ partnerItems, getTotals, toggleExpanded, expanded })

  const { raised, donors } = getTotals(partnerItem)
  const goal = partnerItem.goal.replace(/\.0+$/, '')
  const raisedPresent = !!Number(raised)
  const goalPresent = !!Number(goal)

  const amountRaised = raisedPresent &&
    <span>
      <CountUpWrapper amount={raised} prefix="$" className="fw-bold" />
      {
        goalPresent
        ? ` raised of ${formatUsdAmount(goal)} goal`
        : <span>
            {' raised by '}
            <CountUpWrapper amount={donors} />
            {donors == 1 ? ' person' : ' people'}
          </span>
      }
    </span>


  return (
    <div className="d-flex flex-column gap-3">
      {
        goalPresent && raisedPresent &&
        <div className="goal-with-progress d-flex flex-column gap-2">
          <div className="text-primary">
            {amountRaised}
            {breakdown.toggle}
          </div>
          <Progress raised={raised} goal={goal} />
        </div>
      }
      <div className="d-flex flex-wrap align-items-end justify-content-between column-gap-3 row-gap-2">
        {
          !goalPresent &&
          <p className="mb-0">
            {amountRaised}
            {breakdown.toggle}
          </p>
          || !raisedPresent &&
          <p className="text-body-secondary mb-0">
            {
              widget.show_donate_action
              ? 'Be the first to donate to this worthy cause!'
              : `Fundraiser goal: ${formatUsdAmount(goal)}`
            }
          </p>
        }
        {
          widget.show_donate_action
          ? fundraiserUrl
          ? <a href={fundraiserUrl} className="btn btn-primary" target="_blank">
              {donateLabel || 'Donate'}
            </a>
          : <button
              type="button"
              className="btn btn-primary"
              onClick={() => sendMessage('donateClicked')}
            >
              {donateLabel || 'Donate'}
            </button>
          : <Footer footer={footer} />
        }
      </div>
      {createPortal(
        breakdown.expand
      , document.getElementById('ExpandRoot')
      )}
    </div>
  )
}

export default Content
